import React, { useState, useEffect } from 'react';
import './InfoView.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Countdown from './Countdown';
import EssentialLinkGrid from '../components/EssentialLinkGrid';
import WifiOptionComponent from '../components/WifiOptionComponent';

const InfoView: React.FC = () => {
  const [showCountdown, setShowCountdown] = useState(true);
  
  useEffect(() => {
    const checkTime = () => {
      const hackStartDate = new Date('2026-01-17T03:00:00Z'); // Jan 16 10PM EST = Jan 17 3AM UTC
      const now = new Date();
      setShowCountdown(now < hackStartDate);
    };
    
    checkTime();
    const interval = setInterval(checkTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const wifiNetworks = [
    {
      name: "Eduroam",
      description: "Campus-wide network. Feel free to join this network if your school email supports it."
    },
    {
      name: "uoPublic",
      description: "Open connection network with no authentication required."
    }
  ];

  return (
    <Container id="info-view" fluid>
      {showCountdown && (
        <div className="countdown-section">
          <h1 className="hacker-countdown-title font-weight-bold">
            Hacking Begins In
          </h1>
          <Countdown targetDate="2026-01-17T03:00:00Z" />
        </div>
      )}
      <h1 className="hacker-countdown-title font-weight-bold">
        Essential Links
      </h1>
      <div className="grid-container">
        <EssentialLinkGrid />
      </div>
      <Row className="wifi-section justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <WifiOptionComponent networks={wifiNetworks} />
        </Col>
      </Row>
    </Container>
  );
};

export default InfoView;